import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { MarketingProduct } from "@/product-marketing/types";
import { PRODUCT_MARKETING } from "./content";

export const ProductBenefits = ({ product }: { product: MarketingProduct }) => (
  <Stack className="mt-7 grid w-full grid-cols-4 gap-7 border-t border-stroke-secondary/60 pt-8">
    {PRODUCT_MARKETING[product].benefits.map(
      ({ icon: Icon, title, description }) => (
        <Stack key={title} direction="row" align="start" gap="sm">
          <Icon aria-hidden className="mt-1 h-4 w-4 shrink-0 text-orange-60" />
          <Stack gap="xs">
            <Typography variant="subtitleW3">{title}</Typography>
            <Typography textColor="secondary" className="leading-relaxed">
              {description}
            </Typography>
          </Stack>
        </Stack>
      ),
    )}
  </Stack>
);
